import { useTheme } from '@mui/joy/styles';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { BomPartViewByType } from 'bom/enums';
import { ButtonGroup } from 'core/elements';
import { ActionButtonType } from 'core/enums';
import { Color, Variant } from 'theme/enums';

import { useViewByContext } from './state';

export const ViewByButton = () => {
  const { t } = useTranslation();

  const theme = useTheme();

  const { viewBy, changeViewBy } = useViewByContext();

  const buttons = useMemo(() => {
    const color = (type: BomPartViewByType) => (viewBy === type ? Color.SUCCESS : Color.NEUTRAL);

    const variant = (type: BomPartViewByType) =>
      viewBy === type ? Variant.SOFT : Variant.OUTLINED;

    return [
      {
        type: ActionButtonType.BUTTON,
        label: t('buttonLabelViewByPartNumber'),
        value: BomPartViewByType.PART,
        color: color(BomPartViewByType.PART),
        variant: variant(BomPartViewByType.PART),
        onClick: () => changeViewBy(BomPartViewByType.PART),
        active: viewBy === BomPartViewByType.PART,
        sx: {
          border: '1px solid',
          borderColor: theme.palette.neutral.softOutlined,
        },
      },
      {
        type: ActionButtonType.BUTTON,
        label: t('buttonLabelViewByElement'),
        value: BomPartViewByType.ELEMENT,
        color: color(BomPartViewByType.ELEMENT),
        variant: variant(BomPartViewByType.ELEMENT),
        onClick: () => changeViewBy(BomPartViewByType.ELEMENT),
        active: viewBy === BomPartViewByType.ELEMENT,
        sx: {
          border: '1px solid',
          borderColor: theme.palette.neutral.softOutlined,
        },
      },
    ];
  }, [changeViewBy, t, theme.palette.neutral.softOutlined, viewBy]);

  return <ButtonGroup key="viewByButton" buttons={buttons} />;
};
